
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//葡萄牙
export const lang ={
  Please_set_materialtype_in_product_page:"Acesse a página do produto para modificar e definir o tipo de material de cada produto - produtos acabados - produtos semiacabados - acessórios.",
deleteAccount:"Sair",
deleteAccountWillDeleteAllData:"Sair da sua conta excluirá todos os dados e impossibilitará você de fazer login.",
backupDatabase:"banco de dados de backup",
restoreDatabase:"Restaurar banco de dados",
materialtype:"Tipo de material",
Manufacturing:"Versão de fabricação",
Professional:"Versão profissional",
Standard:"Edição Padrão",
product:"Produto final",
halfProduct:"Produtos semi-acabados",
components:"Acessórios",
Parent:"componente pai",
Children:"Subacessórios",
Level:"Hierarquia",
Timing:"Tempo",
PieceCount:"Trabalho por peça",
Wages:"Remunerações",
InternalProcess:"Processo interno",
ExternalProcess:"processo externo",
ProceName:"Nome do processo",
ProceIndex:"Ordem de execução",
ChargeMan:"diretor",
BillMethod:"Método de cobrança",
ConsumTime:"jornada de trabalho",
Accessories:"Acessórios",
Assembly:"Montar",
materials:"materiais",
task:"Tarefa",
process:"processo",
BOM:"BOM",
Production:"Produção",
RestorePurchaseOneUse:"Restaurar compra (um usuário (limitado a compras anteriores))",
buy_fail_try_again:"Por favor clique novamente para comprar",
Export:"Exportar",
Date:"data",
BankDetail:"detalhes bancários",
Seller:"vendedor",
Buver:"comprador",
Currency:"moeda",
CompanyName:"nome da empresa",
ProformaInvoice:"fatura proforma",
Discount:"Desconto",
PayStatus:"Status do pagamento",
ShippingStatus:"Status de envio",
FreightType:"Tipo de transporte",
Shipping:"frete",
Payment:"Pagamento",
Moneyname:"nome da moeda",
Tax:"impostos",
Freight:"Taxas de frete",
Insurance:"seguro",
Bankfee:"taxas bancárias",
Qc:"Certificação de qualidade",
Exchangerate:"taxa de câmbio",
Shippingnumber:"número de envio",
ShipDate:"Data de envio",
Arrivedate:"data de chegada",
Grossweight:"peso bruto",
CubicWeight:"peso cúbico",
Totalpackages:"Número total de pacotes",
Moneytype:"tipo de moeda",
Quotedate:"data da cotação",
Validitydate:"Data válida",
Paymentterm:"expiração do pagamento",
Priceterm:"prazo de preço",
DeliveryTerm:"Prazo de entrega",
BankName:"nome do banco",
BankAddress:"endereço do banco",
SwiftCode:"Código bancário",
Review:"Análise",
Signfor:"Assinar para recibo",
Finance:"finança",
Receiver:"Receptor",
Business:"negócios",
ContactPerson:"Pessoa de contato",
Profit:"lucro",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"Os funcionários devem usar o Google Chrome. Verifique o endereço IP na página de ajuda do APP do computador de serviço principal e, em seguida, insira o endereço na coluna URL de outros navegadores de computador para abrir o login",
newPassword:"Nova Senha",
ForgetPassword:"esqueça a senha",
ContactUs:"Contacte-nos/faça sugestões",
Actualpay_should_big_then_shouldpay:"As receitas reais não podem ser maiores que as contas a receber",
ShopAddress:"Endereço da minha loja Digitalize o código QR para fazer um pedido",
Submit:"enviar",
All:"todos",
OrdernumExists:"O número do pedido já existe",
PermissionDenied:"permissão negada",
StockTransfer:"Transferência de estoque",
FromWarehouse:"Transferência para fora do armazém",
ToWarehouse:"Transferência para armazém",
PleaseUseInWebBrowser:"Use a função de exportação do Excel no Google Chrome",
PleasePrintInWebBrowser:"Use a função de impressão no Google Chrome",
HistoryPrice:"preço histórico",
SerialNumber:"número de série",
Please_Use_In_APP:"Por favor, use-o dentro do software de computador",
Please_Purchase_In_APP:"Por favor compre dentro do APP, não dentro do navegador",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Você pode se conectar ao banco de dados Postgresql. Seus dados serão armazenados no banco de dados Postgresql. Por padrão, você não precisa se conectar ao banco de dados Postgresql. O padrão é o banco de dados Sqlite local.",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Conecte-se ao banco de dados Postgresql, seus dados serão armazenados no banco de dados Postgresql e serão lidos novamente",
Use_sqlite_data_will_store_in_local:"Usando sqlite, os dados serão armazenados na máquina local",
UsePostgresqlDatabase:"Usando banco de dados PGSQL",
UseSqliteDatabase:"Usando banco de dados SQLite",
DatabaseName:"Banco de dados de nomes",
Test_connect:"conexão de teste",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Caso o produto tenha cor ou tamanho, preencha 0 para o estoque inicial. Após adicionar o produto, insira o estoque na compra.",
my:"meu",
my_shop_qrcode_scan:"O código QR da minha loja oferece aos clientes a capacidade de escanear o código para fazer pedidos. O celular do cliente deve estar conectado ao mesmo roteador que o seu computador.",
ip:"PI",
port:"Porta",
orderstatus:"Status do pedido",
image:"foto",
Template:"modelo",
Please_select_a_excel_file:"Selecione um arquivo",
Please_select_only_one_excel_file:"Apenas um arquivo pode ser selecionado",
Connect_Internet_Login_again:"Conecte-se à Internet e faça login novamente antes de comprar",

    productHasValidDate:'Produto tem um período válido',
productHasColor:'Produto tem tamanho de cor',
GeneralGoods:'Bens gerais',
Selected:'Selecionado',
RestorePurchase:'Retomar a compra',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'Compre Invoicing Enterprise Edition 1 usuários permanentemente',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'Compra Invoicing Enterprise Edition é ilimitado para usuários e dispositivos',
Purchasing:'Comprando ... Por favor, espere pacientemente ...',
Validdate:'Período de validade',
Makedate:'Data de produção',
Batch:'Lote',
CheckVersion:'Verifique a versão',
Please_set_this_ip_address_on_App:'Por favor, defina este endereço IP ou endereço IP do computador no aplicativo.',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Abra esta conexão no seu computador ou navegador móvel (conecte o mesmo WiFi)',


    CheckVersion: 'verificar versão',
You_need_to_purchase: 'Você ainda não comprou, por favor, adicione WeChat para Elink9988 E-mail: bvbuy@qq.com',
Thank_for_your_purchase: 'Você já comprou',
New_version_available: 'Existe uma nova versão',
Is_the_latest_version: 'é a versão mais recente',
    please:'por favor',
input:'entrada',
wrong:'errado',
Verifycode:'Código de verificação',
Upload:'Envio',
Download:'Baixar',
You_need_to_purchase_to_continue_use:'Você precisa comprar para continuar usando',
CheckBuy:'Verificar compra',
Exists:'Existe',
NetworkUnavailable:'rede indisponível',
Today:'Hoje',
Yesterday:'Ontem',
ThisMonth:'Este mês',
LastMonth:'Mês passado',
nickname:'apelido',
storeName:'nome da loja',
BuyStandAlone:'comprar versão stand-alone',
PermissionDenied:'Permissão negada',
Boss:'Patrão',

    login:'Entrar',
    operate:'Operar',
    register:'registo',
    username:'Nome de usuário',
    password:'Senha',
    User:'Do utilizador',
    ok:'Está bem',
    back:'De volta',
    success:'Sucesso',
    fail:'Falhou',
    cancel:'Cancelar',
    add:'Adicionar',
    edit:'Editar',
    delete:'Excluir',
    refresh:'Atualizar',
    close:'Perto',
    cancel:'Cancelar',
    return:'Retorna',
    ElinkInvoice:'Fatura Elink',
    Purchase:'Compra',
    BaseData:'Dados base',
    Sell:'Vender',
    PurchaseReturns:'Retornos de compra',
    SellReturns:'Venda de devoluções',
    Inventory:'Inventário',
    Statistics:'Estatisticas',
    Receivable:'A receber',
    Payable:'A pagar',
    Orders:'Encomendas',
    StockTransfer:'Transferência de estoque',
    StockRecall:'Recall de ações',
    Customer:'Cliente',
    Supplier:'Fornecedor',
    Warehouse:'Armazém',
    Color:'Cor',
    Size:'Tamanho',
    Category:'Categoria',
    Category2:'Categoria2',
    Product:'produtos',
    Account:'Conta',
    AccountType:'Categoria da conta',
    Staff:'Funcionários',
    typeone:'Categoria',
    typetwo:'Subcategoria',
    ProductName:'Nome do Produto',
    Specification:'Especificação',
    Barcode:'Código de barras',
    Buyprice:'Preço de compra',
    Sellprice:'Preço de venda',
    Wholesaleprice:'Preço por atacado',
    Currentstock:'Estoque atual',
    Unit:'Unidade',
    Initstock:'Estoque Init',
    Parameter:'Parâmetro',
    Remark:'Observação',
    Supplier:'Fornecedor',
    Customer:'Cliente',
    Staff:'Funcionários',
    Receivable:'A receber',
    payable:'a pagar',
    Receipts:'Recibos',
    Paid:'Pago',
    Preferential:'Preferencial',
    DateDay:'Encontro',
    OrderNum:'Número do pedido',
    Name:'Nome',
    UserName:'Nome de usuário',
    IdNum:'Número de identidade',
    BirthDay:'Aniversário',
    SEX:'Sexo',
    Female:'Fêmea',
    Male:'Masculino',
    Select:'Selecione',
    Address:'Endereço',
    Phone:'telefone',
    Email:'O email',
    CardNum:'Número do cartão',
    Price:'Preço',
    QTY:'Qtd',
    SupplierCategory:'Categoria de Fornecedor',
    CustomerCategory:'Categoria do cliente',
    Power:'Poder',
    Role:'Função',
    save:'Salve ',
    image:'imagem',
    search:'Procurar',
    Year:'Ano',
    Month:'Mês',
    Day:'Dia',
    Total:'Total',
    WorkReport:'Relatório de trabalho',
    Leave:'Sair',
    CheckIn:'Check-in',
    Announcement:'Anúncio',
    Approval:'Aprovação',
    Tracking:'Rastreamento',
    Bill:'Conta',
    OrdersDetail:'Detalhes das Encomendas',
    Expense:'Despesa',
    Income:'Renda',
    Userfor:'Userfor',
    Amount:'Montante',
    Title:'Título',
    News:'Notícia',
    SelectFile:'Selecione o arquivo',
    Content:'Conteúdo',
    Cost:'Custo',
    ApprovalUser:'Usuário de aprovação',
    ApprovalStatus:'Status de aprovação',
    ApprovalRemark:'Observação de aprovação',
    ApprovalDate:'Data de aprovação',
    SubmitDate:'Data de submissão',
    Status:'Status',
    FromDateTime:'De data e hora',
    ToDateTime:'Até a hora da data',
    Subject:'Sujeito',
    Latitude:'Latitude',
    Longitude:'Longitude',
    Print:'Impressão',
    DataTrans:'DataTrans',
    OA:'OA',
    Setting:'Configuração',
    Help:'Socorro',
    ScanOpenInPhone:'Verificar Abrir no Telefone',
    Building:'Construção',
    Room:'Sala',
    HotelCheckIn:'Check-in',
    CheckOut:'Confira',
    Hotel:'Hotel',
    Checkintime:'Verificar em tempo',
    Checkouttime:'Confira o tempo',
    Deposit:'Depósito',
    Cost:'Custo',
    RoomNum:'Quarto Num',
    Rent:'Aluguel',
    costday:'dia de custo',
    rent:'aluguel',
    waternum:'Grau da água',
    electricnum:'Grau elétrico',
    gasnum:'Grau de gás',
    watercost:'custo da água',
    electriccost:'custo elétrico',
    gascost:'custo de gás',
    cleaningcost:'custo de limpeza',
    networkcost:'custo de rede',
    tvcost:'custo de tv',
    managecost:'gerenciar custo',
    othercost:'outro custo',
    totalcost:'custo total',
    remark:'observação',
    addtime:'tempo extra',
    OpenInBrowser:'Abra no navegador',
    InventoryProfit:'Lucro de inventário',
    InventoryLoss:'Perda de inventário',
    Buy:'Comprar',


Refresh:'Atualizar',
Add:'Adicionar',
Search:'Pesquisar',
Records:'registros',
}



// WEBPACK FOOTER //
// ./src/lang/pt.js